// extracted by mini-css-extract-plugin
module.exports = {"main_content":"main_content-1mF1eaKb","end":"end-37GBinZ_"};